export default __webpack_public_path__ + "static/planet-35f81d6585c38f814bb1b121d99ff885.png";